import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".address-heading-module_addressHeading__qy4SZ {\n  display: flex;\n  align-items: center;\n  font-size: var(--z-size-20px);\n}\n.address-heading-module_addressHeading__qy4SZ svg {\n  margin-right: var(--z-size-5px);\n}";
var styles = {"addressHeading":"address-heading-module_addressHeading__qy4SZ"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
//# sourceMappingURL=address-heading.module.scss.js.map
